import { UnitRate } from '@scenario/models/unit-rate.model';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';

export interface UnitRatesState {
  unitRates: UnitRate[];
  isFetching: boolean;
  error?: string;
}

const initialState: UnitRatesState = {
  unitRates: [],
  isFetching: false,
};

export const unitRatesSlice = createSlice({
  name: 'unitRates',
  initialState,
  reducers: {
    retrieveUnitRates: state => {
      state.isFetching = true;
    },
    retrieveUnitRatesSuccess: (state, action: PayloadAction<UnitRate[]>) => {
      state.unitRates = action.payload;
      state.isFetching = false;
    },
    retrieveUnitRatesFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
  },
});

export type UnitRatesViewModel = {
  unitRates: UnitRate[];
  isFetching: boolean;
  error?: string;
};
const selectUnitRates = (state: RootState) => state.unitRates.unitRates;
const selectIsFetching = (state: RootState) => state.unitRates.isFetching;
const selectError = (state: RootState) => state.unitRates.error;

export const selectUnitRatesViewModel = createSelector(
  [selectUnitRates, selectIsFetching, selectError],
  (unitRates, isFetching, error): UnitRatesViewModel => ({
    unitRates,
    isFetching,
    error,
  }),
);
export const { retrieveUnitRates, retrieveUnitRatesSuccess, retrieveUnitRatesFailure } =
  unitRatesSlice.actions;

export default unitRatesSlice.reducer;
